import CustomButton from "@components/buttons/CustomButton";
import GlobalTextInputField from "@components/inputs/GlobalTextInputField";
import SlidingPanel from "@components/sliders/SlidingPanel";
import { cashierApis } from "@services/apis/Cashier";
import {
  AddCashierRequest,
  AddCashierResponse,
} from "@services/models/Cashier/AddCashierModel";
import useSnackbarMessage from "../../../utils/HandleSuccessErrorSnackbars";
import React, { useState } from "react";

interface AddCashierSliderProps {
  isOpen: boolean;
  onClose: () => void;
}

const AddCashierSlider: React.FC<AddCashierSliderProps> = ({
  isOpen,
  onClose,
}) => {
  const [cashierEmail, setCashierEmail] = useState<string>("");
  const [isButtonLoading, setIsButtonLoading] = useState<boolean>(false);
  const { handleError, handleSuccess } = useSnackbarMessage();

  const checkValidEmail = () => {
    if (cashierEmail.length > 0) {
      const emailRegex = new RegExp(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
      );
      return emailRegex.test(cashierEmail);
    }
    return false;
  };

  const handleSubmit = async () => {
    try {
      setIsButtonLoading(true);
      const addCashierRequest: AddCashierRequest = {
        userEmail: cashierEmail,
      };
      const response: AddCashierResponse =
        await cashierApis.giveUserCashierAccess(addCashierRequest);
      handleSuccess({ message: response.msg || "Added Cashier Successfully" });
      onClose();
    } catch (error: any) {
      const errorMessage =
        error?.response?.data?.msg ||
        "Updating status failed. Please try again.";
      handleError({ message: errorMessage });
    } finally {
      setIsButtonLoading(false);
    }
  };

  return (
    <SlidingPanel
      isOpen={isOpen}
      heading={"Add Cashier"}
      onClose={onClose}
      onClickCross={onClose}
      showConfirm={false}
    >
      <div className="flex flex-col px-[16px] py-[16px]">
        <GlobalTextInputField
          placeholder="Enter email id"
          value={cashierEmail}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setCashierEmail(e.target.value)
          }
          title="Enter the Tylt email for cashier access."
        />
        <div className="my-4">
          <CustomButton
            text="ADD CASHIER"
            onClick={handleSubmit}
            isActive={checkValidEmail()}
            isButtonLoading={isButtonLoading}
          />
        </div>
      </div>
    </SlidingPanel>
  );
};

export default AddCashierSlider;
